module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e28586864d5b4f6d48afbf833f8e0ec2.png";